import { hasLinkedGitHubAccountQueryKey } from "@/hooks/useGitHubProfile.ts"
import { withGlobalLoader } from "@/lib/context.ts"
import { getLogger } from "@/lib/logging.ts"
import { Model } from "@/lib/Model.ts"
import { openLinkInNewWindow } from "@/lib/std.ts"

import type { GlobalContext } from "@/lib/context.ts"
import type { Queries } from "@/lib/queries.ts"

export interface GitHubIntegrationTabProps {
  context: GlobalContext
  queries: Queries
}

const log = getLogger("GitHubIntegrationTabModel")

export class GitHubIntegrationTabModel extends Model {
  private gitHubConnectionUrl: string | null = null

  constructor(private props: GitHubIntegrationTabProps) {
    super("GitHubIntegrationTabModel")
  }

  readonly connectToGitHub = async () => {
    if (this.gitHubConnectionUrl != null) {
      openLinkInNewWindow(this.gitHubConnectionUrl)
      return
    }

    const url = await withGlobalLoader(this.props.context, this.getGitHubConnectUrl())
    if (url) {
      openLinkInNewWindow(url)
    }
  }

  readonly disconnectFromGitHub = async () => {
    try {
      await withGlobalLoader(this.props.context, this.props.queries.apiClient.unlinkGitHubAccount())
      void this.props.context.queryClient.invalidateQueries({ queryKey: hasLinkedGitHubAccountQueryKey })
    } catch (e) {
      log.error("Failed to disconnect GitHub account:", e)
    }
  }

  private async getGitHubConnectUrl() {
    if (this.gitHubConnectionUrl != null) {
      return this.gitHubConnectionUrl
    }
    try {
      const url = await this.props.queries.apiClient.startLinkGitHubAccountFlow()
      this.gitHubConnectionUrl = url
      return url
    } catch {
      return null
    }
  }
}
